/**
 * ¿La sucursal tiene pin en mapa (lat/lng)?
 * Si lat/lng no vinieron en sesión (caché offline vieja), cae al texto de dirección.
 */
export function branchMissingMapLocation(branch: {
  location?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}): boolean {
  const lat = branch.latitude;
  const lng = branch.longitude;
  if (typeof lat === 'number' && typeof lng === 'number' && Number.isFinite(lat) && Number.isFinite(lng)) {
    return false;
  }
  if (lat === null || lng === null) {
    return true;
  }
  // undefined: sin dato de coords → heurística por texto
  const t = (branch.location ?? '').trim();
  return t.length === 0 || t === 'Dirección no cargada' || t === 'Sin ubicación';
}
